import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly cookies (jwt_token, session_token) on every request
});

// Attach a unique X-Request-Id to every outgoing request so the backend can
// correlate frontend actions with backend log entries end-to-end.
api.interceptors.request.use((config) => {
  config.headers['X-Request-Id'] = crypto.randomUUID();
  return config;
});

export default api;
